import { MessageBar, MessageBarType, Stack } from '@fluentui/react';
import React, { useEffect } from 'react';
import { sanitizeHTML } from '../utils/commonUtilities';
import {
  getNotificationDismissIconStyles,
  getNotificationMessageBarStyles,
  NotificationDivStyle,
} from './Notification.styles';
import { INotificationProps } from './Notifications.model';

export const Notification = React.memo((props: INotificationProps): JSX.Element => {
  useEffect(() => {
    !!props.notification && !props.notification.isDismissed && !!props.onRender && props.onRender(props.notification);
  }, [props.notification]);

  if (props.notification?.isDismissed) {
    return null;
  }

  const onClick: React.MouseEventHandler<HTMLElement> = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!!event && !!event.target) {
      const target = event.target as HTMLElement;
      const href = target.hasAttribute('href') ? target.getAttribute('href') : null;
      if (href && props.onLinkClick) {
        props.onLinkClick(href, props.notification);
      }
    }
  };

  const updateAnchors = (html: string): string => {
    try {
      const htmlDoc = new DOMParser().parseFromString(html, 'text/html');
      if (!!htmlDoc) {
        const anchors = htmlDoc.querySelectorAll('a');
        anchors?.forEach((anchor, i) => {
          // Add logging attributes
          anchor.setAttribute('id', `userNotice_${props.notification.id}_Link_${i}`);
          anchor.setAttribute('data-bi-bhvr', 'CLICK');
          anchor.setAttribute('data-bi-area', 'userNotice');
          anchor.setAttribute('data-bi-formnm', 'maxFunnel');
          anchor.setAttribute('data-bi-name', `userNotice_${props.notification.id}_Link_${i}`);
        });

        // IE does not support firstElementChild, in that case use firstChild instead.
        const firstChild = !!htmlDoc.firstElementChild ? htmlDoc.firstElementChild : (htmlDoc.firstChild as Element);
        return firstChild.innerHTML;
      }
    } catch (error) {
      return html;
    }
  };

  const updatedContent = updateAnchors(props.notification.content);

  return (
    <MessageBar
      styles={getNotificationMessageBarStyles(props.theme, props.useExtendPalette)}
      messageBarType={MessageBarType.info}
      isMultiline={true}
      onDismiss={() => {
        !!props.onDismiss && props.onDismiss(props.notification);
      }}
      messageBarIconProps={{ iconName: 'InfoSolid' }}
      dismissIconProps={{
        iconName: 'ChromeClose',
        id: `notice-close-mark-${props.notification.id}`,
        styles: getNotificationDismissIconStyles(props.theme, props.useExtendPalette),
      }}
      dismissButtonAriaLabel={!!props.getString ? props.getString('CloseButtonText') : 'Close'}
      id={`help-content-notice-${props.notification.id}`}
    >
      <Stack onClick={onClick}>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: props.sanitize ? sanitizeHTML(updatedContent, ['target']) : updatedContent,
          }}
          style={NotificationDivStyle}
        />
      </Stack>
    </MessageBar>
  );
});
